import Http from "@services/http";

export default class CommentsApi {
    static async list(type, id) {
        return await Http.get(`comments/${type}/${id}`, {}, { 'X-Disable-Global-Loader': true }).then(r => r.data);
    }

    static async add(type, id, payload) {
        // payload: { context }
        return await Http.post(`comments/${type}/${id}`, payload, { 'X-Disable-Global-Loader': true }).then(r => r.data);
    }

    static async addReply(type, id, payload) {
        // payload: { comment_id, reply }
        return await Http.post(`comments/${type}/${id}/reply`, payload, { 'X-Disable-Global-Loader': true }).then(r => r.data);
    }

    static async resolve(type, id, payload) {
        // payload: { comment_id }
        return await Http.post(`comments/${type}/${id}/resolve`, payload, { 'X-Disable-Global-Loader': true }).then(r => r.data);
    }

    // Legacy project-specific methods (for backward compatibility)
    static async requestDocument(projectId, payload) {
        // payload: { note, user_ids: number[] }
        return await Http.post(`projects/${projectId}/request-document`, payload, { 'X-Disable-Global-Loader': true }).then(r => r.data);
    }

    static async replaceMember(projectId, payload) {
        // payload: { from_member_id, to_member_id }
        return await Http.post(`projects/${projectId}/replace-member`, payload, { 'X-Disable-Global-Loader': true }).then(r => r.data);
    }

    static async delete(type, id) {
        return await Http.delete(`comments/${type}/${id}`, { 'X-Disable-Global-Loader': true }).then(r => r.data);
    }
}
